/**
 * 레이아웃 관련 상수 정의
 * 태블릿 뷰 모드 설정을 위한 상수들
 */ // 사이드바 너비 상수
export var SIDEBAR_WIDTHS = {
    // 모드별 사이드바 너비
    MOBILE: 0,
    ICON_ONLY: 68,
    COMPACT: 180,
    STANDARD: 220,
    EXPANDED: 280
};
// 태블릿 뷰 모드 기본값
export var DEFAULT_TABLET_VIEW_MODE = 'balanced';
// 태블릿 뷰 모드 옵션 (UI 표시용)
export var TABLET_VIEW_MODE_OPTIONS = [
    {
        value: 'sidebar-default',
        label: 'sidebar_default_mode',
        description: 'sidebar_default_desc'
    },
    {
        value: 'content-focused',
        label: 'content_focused_mode',
        description: 'content_focused_desc'
    },
    {
        value: 'balanced',
        label: 'balanced_mode',
        description: 'balanced_mode_desc'
    }
];
// 브레이크포인트 상수 - 모든 앱에서 사용하는 단일 진실 소스
export var LAYOUT_BREAKPOINTS = {
    // 주요 브레이크포인트
    MOBILE_MIN: 0,
    MOBILE_MAX: 767,
    TABLET_MIN: 768,
    TABLET_MAX: 1279,
    DESKTOP_MIN: 1280,
    DESKTOP_LARGE: 1536,
    // Icon-only 모드 전환점 (사이드바 너비와 동기화)
    ICON_ONLY_MAX: 1023,
    // 별칭 (호환성 유지)
    SM: 640,
    MD: 768,
    LG: 1280,
    XL: 1536
};
// 뷰포트 체크 헬퍼 함수
export var isTabletView = function(width) {
    return width >= LAYOUT_BREAKPOINTS.TABLET_MIN && width <= LAYOUT_BREAKPOINTS.TABLET_MAX;
};
export var isMobileView = function(width) {
    return width <= LAYOUT_BREAKPOINTS.MOBILE_MAX;
};
export var isDesktopView = function(width) {
    return width >= LAYOUT_BREAKPOINTS.DESKTOP_MIN;
};
// 추가 헬퍼 함수
export var isSmallScreen = function(width) {
    return width < LAYOUT_BREAKPOINTS.SM;
};
export var isMediumScreen = function(width) {
    return width >= LAYOUT_BREAKPOINTS.SM && width < LAYOUT_BREAKPOINTS.LG;
};
export var isLargeScreen = function(width) {
    return width >= LAYOUT_BREAKPOINTS.LG;
};
// 사이드바 너비 결정 함수
export var getSidebarWidth = function(width) {
    if (width <= LAYOUT_BREAKPOINTS.MOBILE_MAX) {
        return SIDEBAR_WIDTHS.MOBILE;
    }
    if (width < LAYOUT_BREAKPOINTS.DESKTOP_MIN) {
        return SIDEBAR_WIDTHS.ICON_ONLY; // 태블릿: 아이콘만
    }
    return SIDEBAR_WIDTHS.STANDARD; // 데스크톱: 전체 너비
};
// 사이드바 모드 체크 함수
export var isIconOnlyMode = function(width) {
    return width > LAYOUT_BREAKPOINTS.MOBILE_MAX && width <= LAYOUT_BREAKPOINTS.ICON_ONLY_MAX;
};
// 사이드바가 실제로 줄어드는 시점 체크
export var shouldCollapseSidebar = function(width) {
    return width <= LAYOUT_BREAKPOINTS.ICON_ONLY_MAX;
};
